export const SkillsLists = [
    {
        header: "Front-End",
        skills: [
            "ReactJS", "TailwindCSS", "HTML", "CSS", "Bootstrap"
        ].join(', ')
    },
    {
        header: "Back-End",
        skills: [
            "NodeJS", "Express", "MongoDB", "Mongoose", "Axios"
        ].join(', ')
    },
    {
        header: "Langages",
        skills: [
            "HTML", "CSS", "JavaScript", "TypeScript", "C", "C#", "Python"
        ].join(', ')
    }
]